import { appConfig } from '../../../../../config/customization';

const row = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  boxSizing: 'border-box',
  width: '100%',
  padding: '5px 6px'
};

export default {
  oddRow: {
    ...row,
    background: appConfig.colors.oddRowColor
  },
  evenRow: {
    ...row,
    background: appConfig.colors.evenRowColor
  }
};
